export const allEmotions = ["Happy", "Sad", "Angry", "Loved"];
export const emotionsMap = {
  Happy: "😊",
  Sad: "😢",
  Angry: "😡",
  Loved: "😍",
};
export const emotionsNumMap = {
  Happy: 0,
  Sad: 1,
  Angry: 2,
  Loved: 3,
};
export const emotionsRootWord = {
  Happy: "Happiness",
  Sad: "Sadness",
  Angry: "Anger",
  Loved: "Love",
};

export const Emotions = {
  Happiness: 0,
  Sadness: 1,
  Anger: 2,
  Love: 3,
};
export const emotionsWriteUp = {
  Happy: {
    definition: "Feeling or showing pleasure or contentment.",
    synonyms: ["contented", "joyous", "cheerful", "merry"],
    message:
      "In this fast and volatile world, happiness is hard to come by 😰Cherish this moment and celebrate! Tell your friends that you love them 💌",
  },
  Sad: {
    definition: "feeling or showing sorrow; unhappy.",
    synonyms: ["unhappy", "sorrowful", "depressed", "downcast"],
    message:
      "We all have our tough days, but they make us stronger 💪🏼 Give yourself space to breathe",
  },
  Angry: {
    definition:
      "feeling or showing strong annoyance, displeasure, or hostility; full of anger.",
    synonyms: ["irate", "annoyed", "crossed"],
    message:
      "We get you're upset, and maybe for a good reason 🙏🏼 But don't be hasty!",
  },
  Loved: {
    definition: "feel deep affection for (someone).",
    synonyms: ["adore", "cherish"],
    message: "We're happy for you! Cherish this moment",
  },
};
